import React, { useState, useEffect } from 'react';
import { Input, Flex } from '@chakra-ui/react';

const BudgetTimeSelector = ({ value = "00:00", onChange, disabled }) => {
    const parseTime = (time) => {
        const [h, m] = time.split(":").map(Number);
        return {
            hours: isNaN(h) ? 0 : h,
            minutes: isNaN(m) ? 0 : m
        };
    };

    const { hours: initialHours, minutes: initialMinutes } = parseTime(value);
    const [hours, setHours] = useState(initialHours);
    const [minutes, setMinutes] = useState(initialMinutes);

    useEffect(() => {
        // Keep parent in sync when state changes
        onChange(`${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`);
    }, [hours, minutes]);

    const updateTime = (type, rawValue) => {
        let num = parseInt(rawValue.replace(/\D/g, ""), 10);
        if (isNaN(num)) num = 0;

        if (type === "hours") {
            num = Math.max(0, Math.min(num, 23));
            setHours(num);
        } else {
            num = Math.max(0, Math.min(num, 59));
            setMinutes(num);
        }
    };

    const handleKeyDown = (e, type) => {
        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
            const delta = e.key === "ArrowUp" ? 1 : -1;
            if (type === "hours") {
                setHours(h => Math.max(0, Math.min(23, h + delta)));
            } else {
                setMinutes(m => Math.max(0, Math.min(59, m + delta)));
            }
        }
    };

    const snapToNearest15 = () => {
        const rounded = Math.round(minutes / 15) * 15;
        setMinutes(rounded === 60 ? 45 : rounded); // prevent overflow to 60
    };

    return (
        <Flex align="center">
            <Input
                value={String(hours).padStart(2, "0")}
                onChange={(e) => updateTime("hours", e.target.value)}
                onKeyDown={(e) => handleKeyDown(e, "hours")}
                textAlign="center"
                size="xs"
                variant="unstyled"
                maxW="24px"
                isDisabled={disabled}
            />
            <span>:</span>
            <Input
                value={String(minutes).padStart(2, "0")}
                onChange={(e) => updateTime("minutes", e.target.value)}
                onBlur={snapToNearest15}
                onKeyDown={(e) => handleKeyDown(e, "minutes")}
                textAlign="center"
                size="xs"
                variant="unstyled"
                maxW="24px"
                isDisabled={disabled}
            />
        </Flex>
    );
};

export default BudgetTimeSelector;
